export const PortalBarKeyCombo = "shift + s";
